import { Divider, Box, Typography } from "@mui/material";

export default function QuoteDesc() {
	const content = (
		<Box sx={{ my: "2rem" }}>
			<Typography variant="h4" sx={{ color: "#034052", fontWeight: "bold" }}>
				{" "}
				Get a Free Domestic or International Business Shipping Quote Online
			</Typography>
			<Divider sx={{ width: "20%", background: "red", my: "2rem" }} />
			<Typography variant="body1">
				Packages and pallets, big and small, we can offer you an instant quote
				for your shipping needs both domestically and internationally. Fill out
				your shipment details below to discover your quotes. If you are
				satisfied, simply continue to book.
			</Typography>
		</Box>
	);

	return content;
}
